import React from 'react'
import styled from 'styled-components'
import SvgLogoAdmin from './SvgComponent';
import "./Styles/Fonts.css"

const LoginForm = ({setLoginPassword, setLoginEmail, login, loginErr}) => {
    return (
        <FormWrapper>
            <FormContainer>
               <LogoContainer>
                   <SvgLogoAdmin/>
               </LogoContainer>
               <FormFieldsContainer>
                  <InputField type="text" placeholder="Email" onChange={(event) => {
                      setLoginEmail(event.target.value)
                  }} />
                  <InputField type="text" placeholder="Password" onChange={(event) => {
                      setLoginPassword(event.target.value)
                  }}/>
                  <Error>{loginErr}</Error>
                  <Btn type="button" value="Log In" onClick={login} />
               </FormFieldsContainer>




            </FormContainer>
        </FormWrapper>
    )
}

export default LoginForm

const FormWrapper = styled.div`
padding: 1rem calc((100vw - 1400px) / 2);
height: 100vh;
display: flex;
flex-direction: column;
align-items: center;
`
const FormContainer = styled.div`
height: 100vh;
width: 750px;
`
const LogoContainer = styled.div`
display: flex;
justify-content: center;
`
const Avatar = styled.img`
color: #000;
display: flex;
align-items: center;
padding: 0 1rem;
height: 100%;
cursor: pointer;
`
const FormFieldsContainer = styled.form`
display: flex;
flex-direction: column;
align-items: center;
`
const InputField = styled.input`
width: 100%;
height: 95px;
background-color: #EFEFEF;
outline: none;
border: none;
font-family: Gilroy-Medium;
padding: 0.5em 0 0.5rem 2rem;
font-size: clamp(0.8rem, 4vw, 1.5rem);
margin: 1rem;
&::placeholder{
    color: #BFBFBF;

}
`
const Error = styled.p`
width: 100%;
font-family: Gilroy-Medium;
padding: 0.5em 0 0.5rem 2rem;
font-size: clamp(0.8rem, 4vw, 1.5rem);
margin: 0 0 1rem 0;
color: red;
`
const Btn = styled.input`
outline: none;
border: none;
width: 180px;
height: 44px;
background-color: #4C52EA;
color: #fff;
border-radius: 5px;
font-size: clamp(0.5rem, 3vw, 1.2rem);
transition: 0.2s ease;

&:hover{
    cursor: pointer;
    transform: scale(1.1);
  z-index:100;
}
`